import classnames from 'classnames';
import { camelizeKeys } from 'humps';
import { Redirect } from 'react-router-dom';
import React, { Component } from 'react';
import { NavItem, Nav, NavLink, TabContent, TabPane, Row } from 'reactstrap';

import Loading from '../../components/Loading';
import LodgeBookings from './LodgeBookings';
// import InjectApiData from './InjectApiData';
import FlightsBookings from './FlightsBookings';
import { isSuperUser } from '../../lib/utils';
import api from '../../lib/api';

export default class BookingsDashboard extends Component {
  state = { activeTab: 'lodge', data: null };

  async componentDidMount() {
    const { data } = await api.getWithToken('payments/invoices');

    this.setState({ data });
  }

  toggle = e => {
    const tab = e.target.name;
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab });
  };

  filterLineItems(type) {
    return this.state.data.line_items.filter(li => li.item_type === type);
  }

  render() {
    const { activeTab, data } = this.state;

    if (!isSuperUser()) return <Redirect to="404" />;

    if (!data) return <Loading size="small" />;

    const flights = camelizeKeys(this.filterLineItems('flight'));
    const lodges = camelizeKeys(this.filterLineItems('lodge'));

    return (
      <div className="container-fluid">
        <div className="white-panel admin-dash">
          <Nav tabs className="admin-tabs">
            <NavItem>
              <NavLink
                name="lodge"
                className={classnames({ active: activeTab === 'lodge' })}
                onClick={this.toggle}
              >
                Lodge
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                name="flight"
                className={classnames({ active: activeTab === 'flight' })}
                onClick={this.toggle}
              >
                Flights
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="lodge">
              <Row>
                <LodgeBookings data={lodges} />
              </Row>
            </TabPane>
            <TabPane tabId="flight">
              <Row>
                <FlightsBookings data={flights} />
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/BookingsDashboard/BookingsDashboard.jsx